export default {
    namespaced: true,

    state: {
        showDialog: false,
        initDialogOptions: {
            title: '',
            text: '',
            outsideClose: false,
        },
        dialogOptions: {
            title: '',
            text: '',
            outsideClose: false,
        },
    },
    mutations: {
        setShowDialog(state, flag) {
            state.showDialog = flag;
        },

        setDialogOptions(state, options = {}) {
            state.dialogOptions = {
                ...state.dialogOptions,
                ...options,
            };
        },
    },
    actions: {
        showDialog({ commit }, options = {}) {
            commit('setShowDialog', true);
            commit('setDialogOptions', options);
        },

        hideDialog({ state, commit }) {
            commit('setShowDialog', false);
            commit('setDialogOptions', state.initDialogOptions);
        },
    },
    getters: {
        getShowDialog: state => state.showDialog,
        getDialogOptions: state => state.dialogOptions,
    },
};
